import React from 'react'

import { StaticQuery, graphql, Link } from "gatsby";

class NavbarElement extends React.Component{
    render(){
        return(<Link to={this.props.link} className="dropNavItem sideThing"><li className="thatLink"><p className="dropSideTextItem">{this.props.title}</p></li></Link>);
    }
}
export default NavbarElement